module.exports = __webpack_public_path__ + "static/media/GR.da1b951c.svg";